import { ProcessStatusCell } from "components/atoms";
import { I18nTranslator, translations } from "utils/i18n";
import { GridColDef, GridValidRowModel } from "@mui/x-data-grid";
import { Typography } from "@mui/material";
import { theme } from "themes";
import { EProcessStatus } from "model";

type SIZE_CELL = "small" | "medium" | "large" | "full" | number;

const getSizeOfCell = (size: SIZE_CELL) => {
  switch (size) {
    case "small":
      return {
        width: 160,
      };
    case "medium":
      return {
        width: 260,
      };
    case "large":
      return {
        width: 360,
      };
    case "full":
      return {
        flex: 1,
        minWidth: 360,
      };
    default:
      return {
        width: size,
      };
  }
};

interface ICellProps<T extends GridValidRowModel> extends GridColDef<T,any> {
  size?: SIZE_CELL;
  align?: "left" | "center" | "right";
}

export const createCell = <T extends GridValidRowModel>(props: ICellProps<T>) => {
  const { size = "medium", align = "left" } = props;
  const cell = Object.assign(
    {
      align: align,
      headerAlign: "left",
      sortable: true,
      valueFormatter: (params) => {
        if (typeof params.value === "number") {
          return params.value.toLocaleString();
        }
      },
      ...props,
    } as GridColDef<T, any>,
    getSizeOfCell(size)
  );
  return cell as GridColDef<T, any>;
};

export const renderSTT = <T extends GridValidRowModel>(name: string = "no") => {
  return createCell<T>({
    field: name,
    headerName: I18nTranslator(translations.stt),
    size: 60,
    align: "center",
    headerAlign: "center",
    sortable: true,
  });
};
export const renderProcessStatusCell = () => {
  return createCell<{value: EProcessStatus}>({
    field: "status",
    headerName: I18nTranslator(translations.status),
    align: "left",
    size: "small",
    renderCell: ({ value }) => <ProcessStatusCell value={value!.value} />,
  });
};

export const renderActivationCell = (field?: string) => {
  return createCell({
    field: field || "status",
    headerName: I18nTranslator(translations.masterData.status),
    size: 200,
    align: "left",
    renderCell: ({ value }) => (
      <Typography
        sx={{
          backgroundColor: value
            ? theme.colors.success.main
            : theme.colors.error.main,
          padding: "3px 16px",
          borderRadius: "3px",
          color: "white",
          fontWeight: "bold",
        }}
      >
        {I18nTranslator(
          value
            ? translations.masterData.active
            : translations.masterData.inactive
        )}
      </Typography>
    ),
  });
};
